import Vue from 'vue'
// eslint-disable-next-line import/no-extraneous-dependencies,@typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-extraneous-dependencies
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)
